import { Component, Output, EventEmitter } from '@angular/core';
import { ImageService } from 'src/app/services/image/image.service';
import { environment } from 'src/environments/environment';
import { ApplyService, MyCv } from '../../services/apply.service';

export interface SelectedCVData {
  type: 'uploaded' | 'generated';
  file?: File;
  cvPath?: string;
}

@Component({
  selector: 'app-upload-cv',
  templateUrl: './upload-cv.component.html',
  styleUrls: ['./upload-cv.component.css'],
})
export class UploadCvComponent {
  selectedResumeType: string = 'current';
  uploadedCV: File | null = null;

  showCVSelectionPopup: boolean = false;
  loadingCvs: boolean = false;
  errorCvs: string = '';
  myCvs: MyCv[] = [];
  cvImageUrls: { [key: string]: string } = {};
  selectedCV: MyCv | null = null;

  mainURL = 'assets/cvs/';
  imagePath = environment.apiUrl + this.mainURL;

  @Output() next = new EventEmitter<SelectedCVData>();
  @Output() cancel = new EventEmitter<void>();
  @Output() selectionChange = new EventEmitter<'upload' | 'current'>();

  constructor(
    private applyJobService: ApplyService,
    private imageService: ImageService
  ) {}

  selectResumeType(type: 'upload' | 'current'): void {
    this.selectedResumeType = type;
    this.selectionChange.emit(type);
  }

  onCVDrop(event: DragEvent): void {
    event.preventDefault();
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) this.uploadedCV = files[0];
  }

  onCVSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) this.uploadedCV = input.files[0];
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
  }

  removeCV(): void {
    this.uploadedCV = null;
  }

  openCVSelectionPopup(): void {
    this.showCVSelectionPopup = true;
    this.loadMyCvs();
  }

  closeCVSelectionPopup(): void {
    this.showCVSelectionPopup = false;
  }

  loadMyCvs(): void {
    this.loadingCvs = true;
    this.errorCvs = '';

    this.applyJobService.getMyCvs().subscribe({
      next: (cvs) => {
        this.myCvs = cvs.filter(cv => cv.pdfPath || cv.wordPath);
        this.loadingCvs = false;
        this.loadAllImages();
      },
      error: () => {
        this.errorCvs = 'Failed to load CVs. Please try again.';
        this.loadingCvs = false;
      }
    });
  }

  loadAllImages(): void {
    this.myCvs.forEach((cv) => {
      if (cv.imagePath) {
        const fullImageUrl = this.imagePath + cv.imagePath;
        this.imageService.getSecureImage(fullImageUrl).subscribe({
          next: (blobUrl) => {
            this.cvImageUrls[cv.imagePath] = blobUrl;
          },
          error: () => {
            this.cvImageUrls[cv.imagePath] = 'assets/img/placeholder.png';
          }
        });
      }
    });
  }

  getImageUrl(imagePath: string): string {
    return this.cvImageUrls[imagePath] || 'assets/img/placeholder.png';
  }

  selectCVFromPopup(cv: MyCv): void {
    this.selectedCV = cv;
    this.showCVSelectionPopup = false;
  }

  removeSelectedCV(): void {
    this.selectedCV = null;
  }

  disableRightClick(event: MouseEvent): void {
    event.preventDefault();
  }

  canProceed(): boolean {
    if (this.selectedResumeType === 'upload') return !!this.uploadedCV;
    if (this.selectedResumeType === 'current') return !!this.selectedCV;
    return false;
  }

  onNext(): void {
    if (this.selectedResumeType === 'upload' && this.uploadedCV) {
      console.log('📎 Emitting uploaded CV file:', this.uploadedCV.name);
      this.next.emit({ type: 'uploaded', file: this.uploadedCV });

    } else if (this.selectedResumeType === 'current' && this.selectedCV) {
      const cvPath = this.selectedCV.pdfPath;
      console.log('📋 Selected CV object:', this.selectedCV);
      console.log('📋 Emitting cvPath:', cvPath);
      this.next.emit({ type: 'generated', cvPath });

    } else {
      console.warn('⚠️ CV not ready', {
        selectedResumeType: this.selectedResumeType,
        canProceed: this.canProceed()
      });
    }
  }

  onCancel(): void {
    this.cancel.emit();
  }
}